// extracted by mini-css-extract-plugin
export default {"accountHeader":"ui-z","newDesignAccountHeader":"vi-z","primeBadge":"wi-z","logout":"xi-z"};